<template>
  <div id="app">
<!-- <LoadingUI ref="loadingUI"/> -->
    <router-view></router-view>
  </div>
</template>

<script>
// 也可以删除 import LoadingUI 那一行，因为用不到了
// import LoadingUI from './utils/LoadingComponent.vue';

export default {
  name: 'App',
  components: {
    // LoadingUI,  // 注释掉注册
  },
  mounted() {
    // 以下全部注释，或者直接清空 mounted 方法
    /*
    this.$router.beforeEach((to, from, next) => {
      this.$refs.loadingUI.startLoading();
      next();
    });

    this.$router.afterEach(() => {
      setTimeout(() => {
        this.$refs.loadingUI.stopLoading();
      }, 500);
    });
    */
  },
};
</script>

